var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickenRoast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.00024C4.75 5.58603 4.41421 5.25024 4 5.25024C3.58579 5.25024 3.25 5.58603 3.25 6.00024V7.25024H2C1.58579 7.25024 1.25 7.58603 1.25 8.00024C1.25 8.41446 1.58579 8.75024 2 8.75024H3.68934L5.57283 10.6337C5.14757 12.3298 7.05646 15.2993 8.07107 16.3139C9.24264 17.4855 11.1421 17.4855 12.3137 16.3139C13.4853 15.1424 13.4853 13.2429 12.3137 12.0713C11.2991 11.0567 8.32951 9.14776 6.63348 9.57306L4.75 7.68958V6.00024Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.25C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H19.5613C19.8358 20.9076 20 20.473 20 20V19.8815C20 16.3824 17.726 13.2894 14.3862 12.2457C14.3334 12.2292 14.2805 12.2132 14.2275 12.1979C15.0593 13.88 14.7749 15.974 13.3744 17.3746C11.617 19.1319 8.76778 19.1319 7.01042 17.3746C6.53966 16.9038 5.96181 16.1543 5.44226 15.2994C4.52549 16.6112 4 18.1994 4 19.8815V20C4 20.473 4.16419 20.9076 4.43868 21.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenRoast);
export default __webpack_public_path__ + "static/media/chicken-roast.966a3276865fa61f0da21c66fb1743bc.svg";
export { ForwardRef as ReactComponent };